import { Dropdown } from 'module/ui/components/atoms/dropdown/dropdown';
import { SelectionActionPopover } from 'module/ui/components/atoms/rich-text-editor/editor-popover/selection-action-popover';
import { EditorPopoverContentProps } from 'module/ui/components/atoms/rich-text-editor/editor-popover/types';
import { Editor } from '@tiptap/core';
import { FC } from 'react';
import {
  askAiCommandDetailMap,
  getAskAiCommandsMenu,
  AskAiToolbarConfig,
} from '../../../../toolbar/ask-ai-commands';

const AskAiCommandsAsMenu: FC<
  EditorPopoverContentProps & { config?: AskAiToolbarConfig }
> = ({ editor, closePopover, config }) => {
  return (
    <Dropdown
      open
      getPopupContainer={(triggerNode) => triggerNode.parentElement as any}
      menu={{
        items: getAskAiCommandsMenu(config),
        onClick: ({ key }) => {
          if (editor) {
            askAiCommandDetailMap[key].execute({ editor });
          }
          closePopover();
        },
      }}
      placement="bottomLeft"
    >
      <div style={{ width: 1, height: 1 }} />
    </Dropdown>
  );
};

interface Props {
  editor: Editor;
  config?: AskAiToolbarConfig;
}

const alwaysShowWhenPossible = () => true;

export const AskAiToolbar: FC<Props> = ({ editor, config }) => {
  return (
    <SelectionActionPopover
      editor={editor}
      content={(props) => <AskAiCommandsAsMenu {...props} config={config} />}
      placement="bottomLeft"
      canShow={alwaysShowWhenPossible}
      positionRelativeToStartOfSelection={false}
    />
  );
};
